import { useState } from 'react';
import { Modal } from '@mantine/core';
import { NewsletterInfoTip } from './NewsletterInfoTip';
import type { NewsletterCampaignDetail } from './newsletterUtils';

const pixelHelp = 'Les chargements du pixel partagé sont indicatifs. Les protections des messageries peuvent charger ou bloquer les images ; ce compteur ne mesure ni les lecteurs uniques ni la réception en boîte principale.';
type AddressList = 'bad' | 'suppressed' | 'unsubscribed';

export function NewsletterReportMetrics({ campaign }: { campaign: NewsletterCampaignDetail }) {
  const [selectedList, setSelectedList] = useState<AddressList | null>(null);
  const lists = {
    bad: {title: 'Mauvaises adresses', addresses: campaign.bad_addresses || [], id: 'bad-addresses'},
    suppressed: {title: 'Adresses supprimées avant envoi', addresses: campaign.suppressed_addresses || [], id: 'suppressed-addresses'},
    unsubscribed: {title: 'Désinscriptions', addresses: campaign.unsubscribed_addresses || [], id: 'unsubscribed-addresses'},
  };
  const selected = selectedList ? lists[selectedList] : null;
  const addressMetric = (key: AddressList, count: number, id?: string) => <article className="stat-card" aria-label={lists[key].title} key={key}>
    <span>{lists[key].title}</span>
    <strong id={id}>{count}</strong>
    <button type="button" className="newsletter-stat-detail-link" onClick={() => setSelectedList(key)}>Voir détail</button>
  </article>;

  return <>
    <div className="stats-grid newsletter-detail-metrics-grid">
      <article className="stat-card" aria-label="Total"><span>Total</span><strong id="stat-total">{campaign.total_recipient_count || 0}</strong></article>
      <article className="stat-card" aria-label="Envoyés"><span>Envoyés</span><strong id="stat-sent">{campaign.sent_count || 0}</strong></article>
      <article className="stat-card" aria-label="Chargements du pixel">
        <div className="newsletter-stat-label">
          <span>Chargements du pixel</span>
          <NewsletterInfoTip label="À propos des chargements du pixel">{pixelHelp}</NewsletterInfoTip>
        </div>
        <strong id="stat-estimated-opens" className={campaign.tracking_method === 'disabled' ? 'newsletter-stat-status' : undefined}>{campaign.tracking_method === 'disabled' ? 'Désactivé' : campaign.pixel_load_count ?? '—'}</strong>
      </article>
      <article className="stat-card" aria-label="Rejets"><span>Rejets</span><strong id="stat-bounced">{campaign.bounced_count || 0}</strong></article>
      {addressMetric('unsubscribed', campaign.unsubscribed_count || 0, 'stat-unsubscribed')}
      {addressMetric('bad', lists.bad.addresses.length)}
      {addressMetric('suppressed', campaign.suppressed_count || 0)}
    </div>
    <Modal opened={selected !== null} onClose={() => setSelectedList(null)} title={selected?.title || ''} centered size="md"
      closeButtonProps={{'aria-label':'Fermer'}} classNames={{content:'newsletter-recovery-modal'}}>
      {selected && <ul id={selected.id} className="report-list newsletter-address-detail-list">
        {selected.addresses.length === 0 ? <li className="empty-cell">Aucune adresse.</li> : selected.addresses.map(item =>
          <li key={item.email}>{item.email}{selectedList !== 'unsubscribed' && (item.status_detail || item.status) ? ` · ${item.status_detail || item.status}` : ''}</li>)}
      </ul>}
    </Modal>
  </>;
}
